// eslint-disable-next-line import/no-extraneous-dependencies
import gql from 'graphql-tag';
// eslint-disable-next-line import/extensions
import {
  FRAGMENT_PRODUCT_GENERAL, FRAGMENT_PRODUCT_ADDITIONAL, FRAGMENT_PRODUCT_CONFIGURABLE_ITEM,
  FRAGMENT_PRODUCT_SHIPPING_AND_RETURN, FRAGMENT_PRODUCT_RELATED_SEARCH,
  FRAGMENT_PRODUCT_ACCESSORIES, FRAGMENT_PRODUCT_MORE_FROM_COLLECTION,
  FRAGMENT_RECOMMENDEDMATTRESS, FRAGMENT_PRODUCT_GROUPING, FRAGMENT_PRODUCT_GALLERY, FRAGMENT_PRODUCT_GALLERY_PLP,
  FRAGMENT_REVIEW, FRAGMENT_REVIEW_ITEM, FRAGMENT_DELIVERY,
} from './apolloFragment';

export const GET_PRODUCT_GENERAL_DATA = gql`
  ${FRAGMENT_PRODUCT_GENERAL}
  ${FRAGMENT_PRODUCT_ADDITIONAL}
  query getProductGeneralData ($slug: String!, $zipcode: String) {
    products {
      productBySlug(slug: $slug, zipcode: $zipcode){
        general{
          ...fragmentProductGeneral
        }
        additional{
          ...fragmentProductAdditional
        }
        review {
          rating {
            number
            rating
          }
        }
      }
    }
  },
`;

export const GET_PRODUCT_ZIPCODE_DATA = gql`
  ${FRAGMENT_DELIVERY}
  query getProductGeneralData ($slug: String!, $zipcode: String) {
    products {
      productBySlug(slug: $slug, zipcode: $zipcode){
        ... on SimpleProduct{
          mfCollection{
            items{
              grouping{
                attributes {
                  id
                  values {
                    id
                    outOfStock
                  }
                }
                items {
                  product {
                    general{
                      id
                      labels
                    }
                    additional{
                      outOfStock
                      delivery {
                        ...fragmentDelivery
                      }
                    }
                  }
                }
              }
              product {
                general{
                  id
                  labels
                }
                additional{
                  outOfStock
                  delivery {
                    ...fragmentDelivery
                  }
                }
              }
            }
          }
        }
        ... on BundleProduct{
          configItems{
            required{
              optionId
              selections {
                id
                product {
                  labels
                  delivery {
                    ...fragmentDelivery
                  }
                }
              }
            }
            additional{
              optionId
              selections {
                id
                product {
                  labels
                  delivery {
                    ...fragmentDelivery
                  }
                }
              }
            }
          }
        }
        accessories{
          id
          labels
        }
        grouping{
          items {
            product{
              general{
                id
                labels
              }
              additional{
                outOfStock
                delivery {
                  ...fragmentDelivery
                }
              }
            }
          }
          attributes {
            id
            values {
              id
              outOfStock
            }
          }
          foundation {
            attributes {
              id
              values {
                id
                outOfStock
              }
            }
            items{
              product{
                general{
                  id
                  labels
                }
                additional{
                  outOfStock
                }
              }
            }
          }
        }
        general{
          labels
        }
        additional{
          outOfStock
          delivery {
            ...fragmentDelivery
          }
        }
      }
    }
  },
`;

export const GET_PRODUCT_GALLERY_DATA = gql`
  ${FRAGMENT_PRODUCT_GALLERY}
  query getProductGalleryData ($slug: String!) {
    products {
      productBySlug(slug: $slug){
        gallery{
          ...fragmentProductGallery
        }
      }
    }
  },
`;

export const GET_PRODUCT_GALLERY_DATA_PLP = gql`
  ${FRAGMENT_PRODUCT_GALLERY_PLP}
  query getProductGalleryData ($slug: String!, $type: String) {
    products {
      productBySlug(slug: $slug, type: $type){
        gallery{
          ...fragmentProductGalleryPlp
        }
      }
    }
  },
`;

export const GET_PRODUCT_DATA_FOR_GROUPING = gql`
  ${FRAGMENT_PRODUCT_GALLERY}
  ${FRAGMENT_DELIVERY}
  query getProductDataForGrouping($slug: String!, $zipcode: String, $isLayout: Boolean) {
    products {
      productBySlug(slug: $slug, zipcode: $zipcode, isLayout: $isLayout) {
        gallery {
          ...fragmentProductGallery
        }
        general {
          sku
          masterSku
        }
        additional {
          hideConfigureSection
          hideSetIncludes
          desc
          showDesc
          weightAndDim
          specs {
            name
            value
            url
            slug
          }
          delivery {
            ...fragmentDelivery
          }
        }
        ... on BundleProduct{
          pplanInclude
        }
      }
    }
  }
`;

export const GET_PRODUCT_GROUPING_DATA = gql`
  ${FRAGMENT_PRODUCT_GROUPING}
  query getProductGroupingData ($slug: String!, $zipcode: String) {
    products {
      productBySlug(slug: $slug, zipcode: $zipcode){
        grouping{
          ...fragmentProductGrouping
        }
        ... on BundleProduct{
          setSelection {
            count
            label
            isDefault
            isAdditional
          }
          pplanInclude
        }
      }
    }
  },
`;

export const GET_PRODUCT_RELATED_ITEM_DATA = gql`
  ${FRAGMENT_PRODUCT_CONFIGURABLE_ITEM}
  ${FRAGMENT_PRODUCT_MORE_FROM_COLLECTION}
  query getProductRelatedItemData ($slug: String!, $zipcode: String) {
    products {
      productBySlug(slug: $slug, zipcode: $zipcode){
        ... on SimpleProduct{
          mfCollection{
            ...fragmentMoreFromCollection
          }
        }
        ... on BundleProduct{
          configItems{
            ...fragmentConfigurableItem
          }
        }
      }
    }
  },
`;

export const GET_PRODUCT_ACCESSORIES_DATA = gql`
  ${FRAGMENT_PRODUCT_ACCESSORIES}
  query getProductAccessoriesData ($slug: String!, $zipcode: String) {
    products {
      productBySlug(slug: $slug, zipcode: $zipcode){
        accessories{
          ...fragmentAccessories
        }
      }
    }
  },
`;

export const GET_PRODUCT_SHIPPING_AND_RELATED_SEARCH_DATA = gql`
  ${FRAGMENT_PRODUCT_SHIPPING_AND_RETURN}
  ${FRAGMENT_PRODUCT_RELATED_SEARCH}
  query getProductShippingAndRelatedSearchData ($slug: String!) {
    products {
      productBySlug(slug: $slug){
        shippingAndReturn{
          ...fragmentShippingAndReturn
        }
        relatedSearch{
          ...fragmentRelatedSearch
        }
      }
    }
  },
`;

export const GET_PRODUCT_DATA = gql`
  ${FRAGMENT_PRODUCT_GENERAL}
  ${FRAGMENT_PRODUCT_ADDITIONAL}
  ${FRAGMENT_PRODUCT_GALLERY}
  ${FRAGMENT_PRODUCT_CONFIGURABLE_ITEM}
  ${FRAGMENT_PRODUCT_SHIPPING_AND_RETURN}
  ${FRAGMENT_PRODUCT_RELATED_SEARCH}
  ${FRAGMENT_PRODUCT_ACCESSORIES}
  ${FRAGMENT_PRODUCT_MORE_FROM_COLLECTION}
  ${FRAGMENT_PRODUCT_GROUPING}
  query getProductData ($slug: String!, $zipcode: String) {
    products {
      productBySlug(slug: $slug, zipcode: $zipcode){
        general{
          ...fragmentProductGeneral
        }
        gallery{
          ...fragmentProductGallery
        }
        additional{
          ...fragmentProductAdditional
        }
        accessories{
          ...fragmentAccessories
        }
        shippingAndReturn{
          ...fragmentShippingAndReturn
        }
        relatedSearch{
          ...fragmentRelatedSearch
        }
        grouping{
          ...fragmentProductGrouping
        }
        ... on SimpleProduct{
          mfCollection{
            ...fragmentMoreFromCollection
          }
        }
        ... on BundleProduct{
          setSelection {
            count
            label
            isDefault
          }
          configItems{
            ...fragmentConfigurableItem
          }
        }
      }
    }
  },
`;

export const GET_RECOMMENDEDMATTRESS_DATA = gql`
  ${FRAGMENT_RECOMMENDEDMATTRESS}
  query getRecommendedMattress ($bedId: ID! , $bedCostPrice: Float) {
    products {
      recomMattress(bedId:$bedId, bedCostPrice: $bedCostPrice) {
        ...fragmentRedommendedMattress
      }
    }
  },
`;

export const GET_PRODUCT_DATA_ON_GROUPING = gql`
  ${FRAGMENT_PRODUCT_CONFIGURABLE_ITEM}
  ${FRAGMENT_PRODUCT_MORE_FROM_COLLECTION}
  ${FRAGMENT_PRODUCT_SHIPPING_AND_RETURN}
  ${FRAGMENT_PRODUCT_RELATED_SEARCH}
  ${FRAGMENT_PRODUCT_ACCESSORIES}
  ${FRAGMENT_PRODUCT_GROUPING}
  query getSimpleProductData ($slug: String!, $zipcode: String) {
    products {
      productBySlug(slug: $slug, zipcode: $zipcode){
        accessories{
          ...fragmentAccessories
        }
        shippingAndReturn{
          ...fragmentShippingAndReturn
        }
        relatedSearch{
          ...fragmentRelatedSearch
        }
        grouping{
          ...fragmentProductGrouping
        }
        ... on SimpleProduct{
          mfCollection{
            ...fragmentMoreFromCollection
          }
        }
        ... on BundleProduct{
          setSelection {
            count
            label
            isDefault
          }
          configItems{
            ...fragmentConfigurableItem
          }
        }
      }
    }
  },
`;

export const GET_REVIEW = gql`
  ${FRAGMENT_REVIEW}
  ${FRAGMENT_REVIEW_ITEM}
  query getReview (
    $webId: String!,
    $pageId: Int,
    $sortMode:ProductReviewSortModeEnum,
    $rating: [Int],
    $searchRequest: String,
    $isJsonLD: Boolean
   ) {
    products {
      product(webId: $webId) {
        review {
          items (
            pageId: $pageId,
            sortMode: $sortMode,
            rating: $rating,
            searchRequest: $searchRequest,
            isJsonLD: $isJsonLD
          ) {
            items {
              ...fragmentReviewItem
            }
            totalQty
          }
          ...fragmentReview
        }
      }
    }
  }
`;

export const GET_REVIEW_SLUG = gql`
  ${FRAGMENT_REVIEW}
  ${FRAGMENT_REVIEW_ITEM}
  query getReviewSlug (
    $slug: String!,
    $pageId: Int,
    $sortMode:ProductReviewSortModeEnum,
    $rating: [Int],
    $searchRequest: String
    $isJsonLD: Boolean
   ) {
    products {
      productBySlug(slug: $slug) {
        review {
          items (
            pageId: $pageId,
            sortMode: $sortMode,
            rating: $rating,
            searchRequest: $searchRequest,
            isJsonLD: $isJsonLD
          ) {
            items {
              ...fragmentReviewItem
            }
            totalQty
          }
          ...fragmentReview
        }
      }
    }
  }
`;
